import './Index.scss';

import { AsyncStateNotification } from '@ui/notifications';
import { createSonarSelector } from '@lib/selectors';
import { DataDictionaryApiKeysView } from './data-dictionary-api-keys';
import { FeatureRouteWrapper } from '@ui/features';
import { Jira } from './jira';
import { OrganizationsView } from './organizations/OrganizationsView';
import React from 'react';
import { SettingsSidebar } from './Sidebar';
import { Slack } from './slack';
import { SyncView } from '../sync/SyncView';
import { TeamView } from './team';
import { UserSettings } from './UserSettings';
import { ViewArea } from '@ui/general';

import { BASE_ROUTES, FULL_ROUTES, NOTIFICATIONS_COPY } from '@sonar-software/sonar-ts-constants';
import { coreActions, FeatureFlag } from '@sonar-software/sonar-core';
import { Navigate, Route, Routes } from 'react-router-dom';

const patchUserStateSelector = createSonarSelector((state) => state.core.users.byId.patch);
const patchUserCurrentStateSelector = createSonarSelector((state) => state.core.users.current.patch);
const postUserPermissionStateSelector = createSonarSelector((state) => state.core.users.byId.post);

export const SettingsIndex: React.FC = () =>
	<ViewArea
		direction='vertical'
		fullHeight
		fullWidth
		id='settings-view'
		noPadding>
		<SettingsSidebar />
		<Routes>
			<Route
				element={ <OrganizationsView /> }
				path={ BASE_ROUTES.ORGANIZATION } />
			<Route
				element={ <UserSettings /> }
				path={ BASE_ROUTES.USER } />
			<Route
				element={ <TeamView /> }
				path={ BASE_ROUTES.TEAM } />
			<Route
				element={ <Slack /> }
				path={ BASE_ROUTES.SLACK } />
			<Route
				element={
					<FeatureRouteWrapper feature={ FeatureFlag.JiraIntegration }>
						<Jira />
					</FeatureRouteWrapper>
				}
				path={ BASE_ROUTES.JIRA } />
			<Route
				element={
					<FeatureRouteWrapper feature={ FeatureFlag.OpenApiKeyManagement }>
						<DataDictionaryApiKeysView />
					</FeatureRouteWrapper>
				}
				path={ BASE_ROUTES.DATA_DICTIONARY_API_KEYS } />
			<Route
				element={ <SyncView /> }
				path={ BASE_ROUTES.SYNC } />
			<Route
				element={ <Navigate to={ FULL_ROUTES.SETTINGS_USER } /> }
				path='*' />
		</Routes>
		<AsyncStateNotification
			errored={ NOTIFICATIONS_COPY.ERROR_PATCH_USER_UPDATE }
			failed={ NOTIFICATIONS_COPY.FAILED_PATCH_USER_UPDATE }
			received={ NOTIFICATIONS_COPY.SUCCESS_PATCH_USER_UPDATE }
			resetRawAction={ coreActions.resetPatchCoreUsersById }
			stateSelector={ patchUserStateSelector } />
		<AsyncStateNotification
			errored={ NOTIFICATIONS_COPY.ERROR_PATCH_USER_UPDATE }
			failed={ NOTIFICATIONS_COPY.FAILED_PATCH_USER_UPDATE }
			received={ NOTIFICATIONS_COPY.SUCCESS_PATCH_USER_UPDATE }
			resetRawAction={ coreActions.resetPatchCoreUsersCurrent }
			stateSelector={ patchUserCurrentStateSelector } />
		<AsyncStateNotification
			errored={ NOTIFICATIONS_COPY.ERROR_PATCH_USER_UPDATE }
			failed={ NOTIFICATIONS_COPY.FAILED_PATCH_USER_UPDATE }
			received={ NOTIFICATIONS_COPY.SUCCESS_PATCH_USER_UPDATE }
			resetRawAction={ coreActions.resetPostCoreUsersById }
			stateSelector={ postUserPermissionStateSelector } />
	</ViewArea>;

